export const SimilarProductRecommendations = "de5d999ae754332b736ca71452696226471aa28890c99cc6c0828914d3954d6a";